import React, { Component }      from 'react';
import {connect}                 from 'react-redux';
import {Field, reduxForm, reset} from 'redux-form';
import Dropzone                  from 'react-dropzone';
import validate                  from '../../../service/validate_nave';
import {SendPublic,
        SetValidUrlYoutube,
        ClearUrl,
        GetRegistroPostTurma}    from '../../../actions/turmaAction';
import {SetError}                from '../../../actions/notificacaoAction'; 
import renderField               from '../../../container/renderFieldTextArea';
import RenderPrevImg             from '../../../container/renderPrevImagemTimeLine'; 
import RenderFormTextVideo       from '../../../container/renderFormTextVideo';
import '../../../css/professor/style_form_post.css';

class Turma_Post_Form extends Component {

    constructor(props){

        super(props)

        this.state = {
            publicImg        : false,
            publicMov        : false,
            buttonDisabled   : false,
            validMov         : false,
            publicText       : "",
            video            : "",
            errors           : {},
            use_id           : this.props.session.id,
            per_id           : this.props.session.perfil,
            tur_id           : (this.props.session.turma ? this.props.session.turma : this.props.tur_id),
            post_tipo        : 1,
            files            : null,
            textButtonPublic : "Publicar"
        }

        this.onChange      = this.onChange.bind(this);
        this.onChangeVideo = this.onChangeVideo.bind(this);
        this.PublicMovie   = this.PublicMovie.bind(this);     
    }
    
    PublicMovie(){
      this.setState({publicMov:true,publicImg:false});
    }  

    onDrop(files) {
      this.setState({selectedImg:files[0].preview,files:files,publicImg:true,publicMov:false,post_tipo:2});
    }

    removeImgSelect(){
     this.setState({selectedImg:[],publicImg:false,post_tipo:1,files:null})
    }
  
    removeMovSelect(){
     this.setState({publicMov:false,post_tipo:1,video: "",validMov:false})
    }

    onChange(e) {
     this.setState({publicText: e.target.value,errors:{}});
    }

    onChangeVideo(e) {
        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ? e.target.value:""),
                        validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1)
                      });
    }

    statesComponente(){
      this.setState({ textButtonPublic:"Publicar",buttonDisabled:false,publicText:"",validMov:false});
    }

    handleSubmit(e) {
         
        this.setState({ textButtonPublic:"Enviando...",buttonDisabled:true});   
        const dados   = {
                         tur_pos_cod_turma   : this.state.tur_id,
                         tur_pos_cod_usuario : this.state.use_id,
                         tur_pos_tipo        : this.state.post_tipo,
                         tur_pos_midia       : (this.state.post_tipo === 3 ? this.props.ClearUrl(e.video) : "" ),
                         tur_pos_post        : e.publicText
                        }                            
        this.props.SendPublic(dados,this.state.files).then((response) =>{
            this.statesComponente();
            this.removeMovSelect();       
            this.removeImgSelect();       
        }).catch((error)=>{
            this.statesComponente();
            this.props.SetError(500);
        });

    }

    render () {
        const {handleSubmit} = this.props;
         return (
          
                <div className="timeline-panel clearfix">
                 
                  <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                    <div className="timeline-body">
                         <Field name="publicText" type="textarea" component={renderField} label="" placeholder="Criar uma publicação"/>
                         {this.state.publicImg ? <RenderPrevImg prevImg={this.state.selectedImg} funcao={this.removeImgSelect.bind(this)}/>:""} 
                         {this.state.publicMov ? <Field name="video" type="text" component={RenderFormTextVideo} placeholder="Criar uma publicação" funcao={this.removeMovSelect.bind(this)} onChange={this.onChangeVideo}/>:""}
                         {this.state.validMov  ? <span className="text-danger"> <h6>Copie e cole uma url válida do Youtube.</h6> </span> : ""}
                    </div>
                    <div className="timeline-panel-footer timeline-foot-comments">
                        <Dropzone className="btn btn-default btn-xs" multiple={false} accept="image/png,image/jpeg" onDrop={this.onDrop.bind(this)}>
                            <div><span className="glyphicon glyphicon-camera"></span></div>
                        </Dropzone> 
                        <button type="button" className="btn btn-default btn-xs" onClick={this.PublicMovie}>
                            <span className="glyphicon glyphicon-facetime-video"></span>
                        </button>
                        <button  type="submit" className="btn btn-primary btn-xs pull-right" disabled={this.state.buttonDisabled}>
                           <span className="glyphicon glyphicon-send"  aria-hidden="true"></span> {this.state.textButtonPublic}
                        </button> 
                    </div>
                 </form>
                </div>);
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('post_nave'));

function mapStateToProps(state){

    return{
           session     : state.auth.session,
           feth_tur_id : state.turmaReducer.fetch_tur_id
          }
}

export default reduxForm({
   form                     : 'post_nave', //                 <------ same form name
   destroyOnUnmount         : true, //        <------ preserve form data
   forceUnregisterOnUnmount : true, // <------ unregister fields on unmount
   onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps,{SendPublic,SetValidUrlYoutube,GetRegistroPostTurma,ClearUrl,SetError})(Turma_Post_Form));




// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/timeline_turma_post_form.js